export const abtastyScript = `
  (function (i, s, o, g, r, a, m) {
    i["abtiming"] = 1 * new Date();
    a = s.createElement(o),
    m = s.getElementsByTagName(o)[0]; a.async = 1; a.src = g; m.parentNode.insertBefore(a, m)
  })(window, document, "script", "//try.abtasty.com/55aebc57d2e61286da5919aa21629cd4.js");
`;

export const abtastyCodeFlagWidgetHandler = `
  window.addEventListener('message', (event) => {
    const allowedOrigins = [
      'https://majstg-www.sunrun.com',
      'https://www.sunrun.com',
    ];

    if (!allowedOrigins.includes(event.origin)) {
      return;
    }

    const { data } = event;

    if (data?.type === 'abTastyCodeFlagWidgetMessage' && data.flag) {
      const { flag } = data;

      window.ABTastyFlagsWidget = window.ABTastyFlagsWidget || {};
      const flagsArray = (window.ABTastyFlagsWidget.flags = window.ABTastyFlagsWidget.flags || []);
      const flagExists = flagsArray.some(existingFlag => existingFlag === flag);

      if (!flagExists) {
        flagsArray.push(flag);
      }
    }
  });
`;
